"use strict";

exports.__esModule = true;
exports.ElementEditorSaveTemplateDialog = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _FormGroupField = require("../../../Form/FormGroupField");
var _ElementThumbnail = require("../../ElementThumbnail");
var _Core = require("../../../Core");
var _LayoutTemplate = require("../../../LayoutTemplate");
var _dec, _class, _ElementEditorSaveTemplateDialog;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ElementThumbnailWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ElementEditorSaveTemplateDialog__ElementThumbnailWrapper",
  componentId: "sc-alksbb-0"
})(["display:flex;flex:1;flex-direction:column;justify-content:center;align-items:center;"]);
var ElementEditorSaveTemplateDialog = exports.ElementEditorSaveTemplateDialog = (_dec = _LayoutTemplate.LayoutTemplateCollectionContext.withContext, _dec(_class = (0, _Core.withTranslator)(_class = (_ElementEditorSaveTemplateDialog = /*#__PURE__*/function (_Component) {
  function ElementEditorSaveTemplateDialog() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      components: collectThumbnailComponents(_this.props.elementEditor.widgets)
    };
    _this.handleSubmit = function (_ref) {
      var name = _ref.name;
      var _this$props = _this.props,
        elementEditor = _this$props.elementEditor,
        layoutTemplateCollection = _this$props.layoutTemplateCollection;
      var element = elementEditor.getElementAt(elementEditor.selectedPath);
      var id = "template-" + element.type.toLowerCase() + "-" + name.toLowerCase().trim().replace(/\W+/g, "-").replace(/^-+|-+$/, "");
      return layoutTemplateCollection.create({
        id: id,
        name: name,
        element: element
      }).then(function () {
        elementEditor.closeSaveTemplateDialog();
      });
    };
    _this.validateName = function (input) {
      var translate = _this.props.translator.translate;
      if (!input) {
        return translate("ElementEditorSaveTemplateDialog.validateName.nameRequired", "Name is required");
      }
    };
    return _this;
  }
  _inheritsLoose(ElementEditorSaveTemplateDialog, _Component);
  var _proto = ElementEditorSaveTemplateDialog.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var elementEditor = this.props.elementEditor;
    var widget = elementEditor.getWidgetAt(elementEditor.selectedPath);
    return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
      isOpen: elementEditor.isSaveTemplateDialogOpen,
      onClose: elementEditor.closeSaveTemplateDialog,
      icon: _icons.IconNames.FLOPPY_DISK,
      title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ElementEditorSaveTemplateDialog.title",
        defaultMessage: "Save {label} Template",
        values: {
          label: widget ? widget.label : ""
        }
      })
    }, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
      onSubmit: this.handleSubmit
    }, function (_ref2) {
      var handleSubmit = _ref2.handleSubmit,
        invalid = _ref2.invalid;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: _core.Classes.DIALOG_BODY
      }, /*#__PURE__*/_react["default"].createElement(ElementThumbnailWrapper, null, /*#__PURE__*/_react["default"].createElement(_ElementThumbnail.ElementThumbnail, {
        components: _this2.state.components,
        height: 96,
        width: 96,
        config: elementEditor.getElementAt(elementEditor.selectedPath)
      })), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "name",
        label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ElementEditorSaveTemplateDialog.nameLabel",
          defaultMessage: "Template Name"
        }),
        helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ElementEditorSaveTemplateDialog.nameHelperText",
          defaultMessage: "Enter a name for this template"
        }),
        requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null),
        validate: _this2.validateName
      }, function (_ref3) {
        var input = _ref3.input;
        return (
          /*#__PURE__*/
          // eslint-disable-next-line jsx-a11y/no-autofocus
          _react["default"].createElement(_core.InputGroup, _extends({}, input, {
            autoFocus: true
          }))
        );
      })), /*#__PURE__*/_react["default"].createElement("footer", {
        className: _core.Classes.DIALOG_FOOTER
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _core.Classes.DIALOG_FOOTER_ACTIONS
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        large: true,
        icon: _icons.IconNames.FLOPPY_DISK,
        intent: _core.Intent.PRIMARY,
        disabled: invalid,
        type: "submit",
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ElementEditorSaveTemplateDialog.saveButton",
          defaultMessage: "Save"
        })
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        large: true,
        minimal: true,
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ElementEditorSaveTemplateDialog.cancelButton",
          defaultMessage: "Cancel"
        }),
        onClick: elementEditor.closeSaveTemplateDialog
      }))));
    }));
  };
  return ElementEditorSaveTemplateDialog;
}(_react.Component), _ElementEditorSaveTemplateDialog.defaultProps = {
  translator: undefined,
  layoutTemplateCollection: undefined
}, _ElementEditorSaveTemplateDialog)) || _class) || _class);
function collectThumbnailComponents(widgets) {
  var components = {};
  for (var i = 0; i < widgets.length; i++) {
    var widget = widgets[i];
    if (widget.components.Thumbnail) {
      components[widget.name] = widget.components.Thumbnail;
    }
  }
  return components;
}